export const BenFn = {
  test() { },
  isMobileByWidth(width = 801) {
    return window.innerWidth < width
  },
  clone<T>(data: T): T {
    // 处理null和undefined
    if (data === null || data === undefined) {
      return data
    }

    // 处理日期类型
    if (data instanceof Date) {
      return new Date(data.getTime()) as unknown as T
    }

    // 处理正则表达式
    if (data instanceof RegExp) {
      return new RegExp(data.source, data.flags) as unknown as T
    }

    // 处理数组
    if (Array.isArray(data)) {
      return data.map((item) => BenFn.clone(item)) as unknown as T
    }

    // 处理对象（包括普通对象和Vue响应式对象）
    if (typeof data === 'object') {
      // 处理Vue3的响应式对象（如reactive创建的对象）
      const isVueReactive = '__v_raw' in data
      const rawData = isVueReactive ? data['__v_raw'] : data

      const newObj = {} as T
      // 遍历对象属性进行递归拷贝
      Reflect.ownKeys(rawData as object).forEach((key) => {
        const prop = key as keyof T
        newObj[prop] = BenFn.clone((rawData as Record<string | symbol, any>)[key])
      })
      return newObj
    }

    // 基本类型直接返回
    return data
  },
  sleep(timeout = 1000) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('done')
      }, timeout)
    })
  },
}
